module.exports = __webpack_public_path__ + "static/media/thunder.f2feac8e.png";